import { render, staticRenderFns } from "./SummaryForm.vue?vue&type=template&id=15b27b65&scoped=true"
import script from "./SummaryForm.vue?vue&type=script&lang=js"
export * from "./SummaryForm.vue?vue&type=script&lang=js"
import style0 from "./SummaryForm.vue?vue&type=style&index=0&id=15b27b65&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b27b65",
  null
  
)

export default component.exports